import React from 'react';
import { Box } from '@mui/material';
import { useState, useEffect, useImperativeHandle, forwardRef } from 'react';
import { styles } from './styles';
import { formatTime } from '~/helpers/utils';

export interface TimerProps {
  onTimeUp: () => void;
  initialTime: number;
  style?: React.CSSProperties;
  autoStart?: boolean;
}

export interface TimerHandle {
  startTimer: () => void;
  resetTimer: () => void;
}

const Timer = forwardRef<TimerHandle, TimerProps>(({ onTimeUp, initialTime, style }, ref) => {
  const [timeLeft, setTimeLeft] = useState<number>(initialTime);
  const [isActive, setIsActive] = useState<boolean>(false);

  useEffect(() => {
    if (!isActive) return;

    if (timeLeft === 0) {
      onTimeUp();
      setIsActive(false);
      return;
    }

    const timerInterval = setInterval(() => {
      setTimeLeft((prevTime) => prevTime - 1);
    }, 1000);

    return () => clearInterval(timerInterval);
  }, [timeLeft, isActive, onTimeUp]);

  useImperativeHandle(ref, () => ({
    startTimer: () => {
      setTimeLeft(initialTime);
      setIsActive(true);
    },
    resetTimer: () => {
      setTimeLeft(initialTime);
      setIsActive(false);
    },
  }));

  return (
    <Box sx={styles.timerContainer} style={style}>
      {formatTime(timeLeft)}
    </Box>
  );
});

Timer.displayName = 'Timer';

export default Timer;
